export const COLUMN_WIDTH = 68;
export const COLUMN_LEFT_WIDTH = 231;
export const COLUMN_LEFT_WIDTH_MOBILE = 116;
